// make external links open in a new tab 
let links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// delete knowledge link if language isn't german
const lang = document.documentElement.lang || '';

if (!lang.startsWith('de')) {
  const link = document.querySelector('header .header__inline-menu a[aria-label="Wissen"]');
  
  // If the link exists, find its closest li parent and remove it
  if (link) {
    const li = link.closest('li');
    if (li) {
      li.remove();
    }
  }
}